var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPremiumPlan(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_696_60580",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -1,
    width: 25,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.101562,
    y: -0.488281,
    width: 24,
    height: 24,
    fill: "#333333"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_696_60580)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.77656 13.2117L10.6516 10.3617L8.35156 8.51172H11.2016L12.1016 5.71172L13.0016 8.51172H15.8516L13.5266 10.3617L14.4016 13.2117L12.1016 11.4367L9.77656 13.2117ZM6.10156 22.5117V14.7867C5.46823 14.0867 4.97656 13.2867 4.62656 12.3867C4.27656 11.4867 4.10156 10.5284 4.10156 9.51172C4.10156 7.27839 4.87656 5.38672 6.42656 3.83672C7.97656 2.28672 9.86823 1.51172 12.1016 1.51172C14.3349 1.51172 16.2266 2.28672 17.7766 3.83672C19.3266 5.38672 20.1016 7.27839 20.1016 9.51172C20.1016 10.5284 19.9266 11.4867 19.5766 12.3867C19.2266 13.2867 18.7349 14.0867 18.1016 14.7867V22.5117L12.1016 20.5117L6.10156 22.5117ZM12.1016 15.5117C13.7682 15.5117 15.1849 14.9284 16.3516 13.7617C17.5182 12.5951 18.1016 11.1784 18.1016 9.51172C18.1016 7.84505 17.5182 6.42839 16.3516 5.26172C15.1849 4.09505 13.7682 3.51172 12.1016 3.51172C10.4349 3.51172 9.01823 4.09505 7.85156 5.26172C6.6849 6.42839 6.10156 7.84505 6.10156 9.51172C6.10156 11.1784 6.6849 12.5951 7.85156 13.7617C9.01823 14.9284 10.4349 15.5117 12.1016 15.5117ZM8.10156 19.5367L12.1016 18.5117L16.1016 19.5367V16.4367C15.5182 16.7701 14.8891 17.0326 14.2141 17.2242C13.5391 17.4159 12.8349 17.5117 12.1016 17.5117C11.3682 17.5117 10.6641 17.4159 9.98906 17.2242C9.31406 17.0326 8.6849 16.7701 8.10156 16.4367V19.5367Z",
    fill: "#2B2B2B"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremiumPlan);
export default __webpack_public_path__ + "static/media/premium_plan.5466ae175ccb558c39faa0b1af38e1f8.svg";
export { ForwardRef as ReactComponent };